// useAnalyticsData hook
// UPDATED: Analytics v2 - removed CompletionStats; now loads FrequentationData (per-mission view)
// NOTE: The useCallback dependency array uses individual filter fields (not the filters object) to
//   avoid spurious re-runs. Update it whenever AnalyticsFilters gains new fields.

import { useState, useEffect, useCallback } from 'react';
import { getFrequentationData, type AnalyticsFilters, type FrequentationData } from '../lib/analytics';

export interface AnalyticsData {
  kpis: FrequentationData[];
  loading: boolean;
  error: string | null;
}

export function useAnalyticsData(filters: AnalyticsFilters): AnalyticsData & { reload: () => void } {
  const [kpis, setKpis] = useState<FrequentationData[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const load = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const data = await getFrequentationData(filters);
      setKpis(data);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Erreur de chargement');
    } finally {
      setLoading(false);
    }
  }, [filters.dateFrom, filters.dateTo, filters.siteId, filters.scheduledTime]);

  useEffect(() => {
    load();
  }, [load]);

  return { kpis, loading, error, reload: load };
}
